import { useAuthenticator } from '@aws-amplify/ui-react';
import { useMutation } from 'react-query';
import { AxiosError } from 'axios';

import { useApiNoSqlContext } from 'src/modules/contexts/ApiNoSqlContext';
import {
	ApiError,
	LayoutlmRequest,
	LayoutlmResponse
} from 'src/modules/generated-api-clients/no-sql';
import { logApiError, logAxiosError, logError, logRequest } from './helpers';
import { MUTATION_KEYS } from './enums';

// /**
//  * Custom hook for performing a zero shot model prediction for classification tasks.
//  * Endpoint: POST '/api/v2/ai/zero-shot'
//  * @returns An object containing the response and error, if any.
//  */
// export const useMutationZeroShotModelPredictionOr404 = () => {
// 	const { client } = useApiNoSqlContext();
// 	const { user } = useAuthenticator(context => [context.user]);

// 	return useMutation<ZeroShotOutput, ApiError, ZeroShotInput>(
// 		async (requestBody: ZeroShotInput) => {
// 			if (!client) {
// 				throw new Error('API client is not initialized');
// 			}
// 			if (user.attributes === undefined) {
// 				throw new Error('AWS Amplify user attributes cannot be undefined');
// 			}

// 			const response = await client.aiModels.layoutlmModelPredictionOr404ApiV2AiLayoutlmFromS3PredictPost(
// 				requestBody
// 			);
// 			logRequest(requestBody, 'POST', MUTATION_KEYS.aiModels.ZeroShotModelPredictionOr404, response);

// 			return response;
// 		},
// 		{
// 			onSuccess: (data: ZeroShotOutput) => {
// 				console.log('Zero shot model prediction successful:', JSON.stringify(data));
// 			},
// 			onError: (error: unknown) => {
// 				if (error instanceof ApiError) {
// 					logApiError(error);
// 				} else if (error instanceof AxiosError) {
// 					logAxiosError(error);
// 				} else {
// 					logError(error, 'Error with zero shot model prediction');
// 				}
// 				return;
// 			}
// 		}
// 	);
// };

/**
 * Custom hook for performing a layoutlm model prediction by S3 bucket file path.
 * Endpoint: POST '/api/v2/ai/layoutlm/from-s3/predict'
 * @returns An object containing the response and error, if any.
 */
export const useMutationLayoutlmModelPredictionOr404 = () => {
	const { client } = useApiNoSqlContext();
	const { user } = useAuthenticator(context => [context.user]);

	return useMutation<LayoutlmResponse, ApiError, LayoutlmRequest>(
		async (requestBody: LayoutlmRequest) => {
			console.log('requestBody:', requestBody);
			if (!client) {
				throw new Error('API client is not initialized');
			}
			if (user.attributes === undefined) {
				throw new Error('AWS Amplify user attributes cannot be undefined');
			}
			const response = await client.aiModels.layoutlmModelPredictionOr404ApiV2AiLayoutlmFromS3PredictPost(
				requestBody
			);
			console.log('response:', response);
			logRequest(requestBody, 'POST', MUTATION_KEYS.aiModels.LayoutlmModelPredictionOr404, response);

			return response;
		},
		{
			onSuccess: (data: LayoutlmResponse) => {
				console.log('Layoutlm model prediction successful:', JSON.stringify(data));
			},
			onError: (error: unknown) => {
				console.log('error:', error);
				if (error instanceof ApiError) {
					logApiError(error);
				} else if (error instanceof AxiosError) {
					logAxiosError(error);
				} else {
					logError(error, 'Error with layoutlm model prediction');
				}
				return;
			}
		}
	);
};
